<template>
	<div class="register">
		<div class="banner">
				<img src="static/img/banner.png">
		</div>
		<div class="content">
			<div class="input marginBtm">
				<input type="text" v-model="phone" placeholder="请输入电话">
				<span class="iconfont icon-shouji"></span>
			</div>
			<div class="input marginBtm">
				<input type="text" v-model="code" placeholder="短信验证码">
				<span class="iconfont icon-iconzhenghe0729fuzhi93"></span>
				<div class="code" v-if="recommendToken" @click="getSignature(recommendToken)">获取</div>
				<div class="code" v-else-if="recommendCode" @click="getSignature(recommendCode)">获取</div>
			</div>
			<div class="input marginBtm">
				<input type="password" v-model="password" placeholder="请输入密码">
				<span class="iconfont icon-mima"></span>
			</div>
			<div class="input">
				<input type="password" v-model="passwords" placeholder="请重复密码">
				<span class="iconfont icon-mima"></span>
			</div>	
			<button type="botton" v-if="recommendToken" @click="register">注册</button>
			<button type="botton" v-else-if="recommendCode" @click="referralRegister">注册</button>
		</div>
	</div>
</template>
<script type="text/javascript">
import axios from 'axios'
	export default {
		name: 'register',
		data(){
			return{
				'phone': '',
				'code': '',
				'password': '',
				'passwords': '',
				'timer': '',
				'recommendToken':this.$route.query.reginal_agency_token,
				'recommendCode': this.$route.query.rcmd_code,
				'click': true,
				'codeClick': true
			}
		},
		mounted() {
			if(this.recommendToken) {
				this.checkAgentToken()
			}else if(this.recommendCode) {
				this.checkRcmdCode()
			}
		},
		watch: {
			
		},
		methods: {
			//判断区域代理二维码
			checkAgentToken: function() {
				var data = {
					'recommendToken': this.recommendToken?this.recommendToken: ''
				}
				this.$http.post(API_ROOT.system + '/agency/checkAgentToken',data).then(response=> {
					var result = response.data
					if(result.success) {
					}else {
						this.$message({
							message: "推荐信息不正确，请退出",
							type: 'error',
							center: true,
							duration: 2000
						})
					}
				},response=> {
					this.$message({
						showClose: true,
						message: "网络繁忙，请稍后重试！",
						type: 'error',
						center: true,
						duration: 2000
					})
				})
			},
			//判断推荐人奖励二维码
			checkRcmdCode: function() {
				var data = {
					'rcmdCode': this.recommendCode?this.recommendCode: ''
				}
				this.$http.post(API_ROOT.statistics + '/recommender/checkRcmdCode',data).then(response=> {
					var result = response.data
					if(result.success) {
					}else {
						this.$message({
							message: "推荐信息不正确，请退出",
							type: 'error',
							center: true,
							duration: 2000
						})
					}
				},response=> {
					this.$message({
						showClose: true,
						message: "网络繁忙，请稍后重试！",
						type: 'error',
						center: true,
						duration: 2000
					})
				})
			},
			//验证码计时
			gainCode:function() {
				var txt = $('.code').text()
				if(txt == '获取' || txt =='重发') {
					clearInterval(this.timer)
					$('.code').text('60')
					var self = this
					this.timer = setInterval(function() {
						var text = $('.code').text()
						if(text == 1) {
							$('.code').text('重发')
							self.codeClick = true
							clearInterval(self.timer)
							return
						}else {
							text--
							self.codeClick = false
							$('.code').text(text)
						}
					},1000)
				}else {
					return
				}
			},
			//获取加密数据
			getSignature: function(recommend) {
				if(!this.codeClick) {
					return
				}
				if(this.phone == '') {
					this.$message({
						message:"请填写手机号！",
						type: 'error',
						center: true,
						duration: 2000
					})
					return
				}else if(this.phone.length != 11) {
					this.$message({
						message:"手机格式有误，请重新输入！",
						type: 'error',
						center: true,
						duration: 2000
					})
					return
				}
				if(recommend == '' || recommend == undefined  || recommend == null) {
					this.$message({
						message:"推荐码不存在，请退出",
						type: 'error',
						center: true,
						duration: 2000
					})
					return
				}
				var data = {
					'phone': this.phone,
					'invitationCode':  recommend
				}
				this.$http.post(API_ROOT.tjuser + '/register/getSignature',data).then(response=> {
					var result = response.data
					if(result.success) {
						this.sendSms(result.data)
					}else {
						this.$message({
							message: result.msg,
							type: 'error',
							center: true,
							duration: 2000
						})
					}
				},response=> {
					this.$message({
						message: "网络繁忙，请稍后重试！",
						type: 'error',
						center: true,
						duration: 2000
					})
				})
			},
			//获取短信
			sendSms:function(sig) {
				var data = {
					signature: sig,
					phoneNumber: this.phone
				}
				this.$http.post(API_ROOT.tjuser + "/register/sendSms",data).then(response=> {
					var result = response.data
					if(result.success) {
						this.$message({
							message: '发送成功',
							type: 'success',
							center: true,
							duration: 2000
						})
						this.gainCode()
					}else {
						this.$message({
							message: result.msg,
							type: 'error',
							center: true,
							duration: 2000
						})
						if(result.msg == '当前手机号已经注册') {
							clearInterval(this.timer);
							$('.code').text('重发')
						}
					}
				},response=> {
					this.$message({
						message: "网络繁忙，请稍后重试！",
						type: 'error',
						center: true,
						duration: 2000
					})
				})
			},
			//区域代理注册
			register:function() {
				if(this.phone == '') {
					this.$message({
						message:"请填写手机号！",
						type: 'error',
						center: true,
						duration: 2000
					})
					return
				}
				if(this.phone.length != 11) {
					this.$message({
						showClose: true,
						message:"手机格式有误，请重新输入！",
						type: 'error',
						center: true,
						duration: 2000
					})
					return
				}
				if(this.code == '') {
					this.$message({
						message:"验证码不能为空",
						type: 'error',
						center: true,
						duration: 2000
					})
					return
				}
				if(this.password == '') {
					this.$message({
						message: "请输入密码",
						type: 'error',
						center: true,
						duration: 2000
					})
					return
				}
				if(this.passwords == '') {
					this.$message({
						message:"请重复密码",
						type: 'error',
						center: true,
						duration: 2000
					})
					return
				}
				if(this.password != this.passwords) {
					this.$message({
						message:"两次密码不相同，请重新输入",
						type: 'error',
						center: true,
						duration: 2000
					})
					return
				}
				var data = {
					phone: this.phone,
					code: this.code,
					password: this.password,
					regType: '0',
					invitationCode: this.recommendToken,
					registerChannel: 'RECOMMEND_REGISTER'
				}
				if(this.click != true) {
					this.$message({
							message: '请不要重复点击',
							type: 'error',
							center: true,
							duration: 1000
						})
					return
				}
				this.click = false
				this.$http.post(API_ROOT.tjuser + '/register/regionalAgencyCreateTjkUser',data).then(response=> {
					var result = response.data
					if(result.success) {
						this.$message({
							message: '注册成功',
							type: 'success',
							center: true,
							duration: 1000
						})
						var self = this
						setTimeout(function () {
							self.$router.push({name: 'download'});
						},1500)
					}else {
						this.click = true
						this.$message({
							message: result.msg,
							type: 'error',
							center: true,
							duration: 1000
						})
					}
				},response=> {
					this.click = true
					this.$message({
						message:'网络繁忙，请稍后重试！',
						type: 'error',
						center: true,
						duration: 1000
					})
				})
			},
			//推荐人注册
			referralRegister: function() {
				if(this.phone == '') {
					this.$message({
						message:"请填写手机号！",
						type: 'error',
						center: true,
						duration: 2000
					})
					return
				} 
				if(this.phone.length != 11) {
					this.$message({
						showClose: true,
						message:"手机格式有误，请重新输入！",
						type: 'error',
						center: true,
						duration: 2000
					})
					return
				}
				if(this.code == '') {
					this.$message({
						message:"验证码不能为空",
						type: 'error',
						center: true,
						duration: 2000
					})
					return
				}
				if(this.password == '') {
					this.$message({
						message: "请输入密码",
						type: 'error',
						center: true,
						duration: 2000
					})
					return
				}
				if(this.passwords == '') {
					this.$message({
						message:"请重复密码",
						type: 'error',
						center: true,
						duration: 2000
					})
					return
				}
				if(this.password != this.passwords) {
					this.$message({
						message:"两次密码不相同，请重新输入",
						type: 'error',
						center: true,
						duration: 2000
					})
					return
				}
				var data = {
					phone: this.phone,
					code: this.code,
					password: this.password,
					regType: '0',
					recommendCode: this.recommendCode,
					registerChannel: 'RECOMMEND_REGISTER'
				}
				if(this.click != true) {
					this.$message({
							message: '请不要重复点击',
							type: 'error',
							center: true,
							duration: 1000
						})
					return
				}
				this.click = false
				this.$http.post(API_ROOT.tjuser + '/register/recommendCreateTjkUser',data).then(response=> {
					var result = response.data
					if(result.success) {
						this.$message({
							message: '注册成功',
							type: 'success',
							center: true,
							duration: 1000
						})
						var self = this
						setTimeout(function () {
							self.$router.push({name: 'download'});
						},1500)
					}else {
						this.click = true
						this.$message({
							message: result.msg,
							type: 'error',
							center: true,
							duration: 1000
						})
					}
				},response=> {
					this.click = true
					this.$message({
						message:'网络繁忙，请稍后重试！',
						type: 'error',
						center: true,
						duration: 1000
					})
				})
			}
		}
	}
</script>





// WEBPACK FOOTER //
// register.vue?f44dd936